module.exports = __webpack_public_path__ + "img/2-1.29bd25bf.png";